import { buildProps as o } from "./index601.js";
import { componentSizes as t } from "./index684.js";
const a = o({
  /**
   * @description type of Tag
   */
  type: {
    type: String,
    values: ["primary", "success", "info", "warning", "danger"],
    default: "primary"
  },
  /**
   * @description whether Tag can be removed
   */
  closable: Boolean,
  /**
   * @description whether to disable animations
   */
  disableTransitions: Boolean,
  /**
   * @description whether Tag has a highlighted border
   */
  hit: Boolean,
  /**
   * @description background color of the Tag
   */
  color: String,
  /**
   * @description size of Tag
   */
  size: {
    type: String,
    values: t
  },
  /**
   * @description theme of Tag
   */
  effect: {
    type: String,
    values: ["dark", "light", "plain"],
    default: "light"
  },
  /**
   * @description whether Tag is rounded
   */
  round: Boolean
}), s = {
  close: (e) => e instanceof MouseEvent,
  click: (e) => e instanceof MouseEvent
};
export {
  s as tagEmits,
  a as tagProps
};
